import React, { createContext, useState } from "react"
export const TransitionContext = createContext({})

function TransitionState({ children }: any) {
  const INITIAL_STATE = {
    inTransition: false,
    // event
    e: false,
    // exit
    exitDelay: 0,
    exitLength: 0,
    exitState: {},
    exitProps: {},
    exitTrigger: false,
    // entry
    entryDelay: 0,
    entryLength: 0,
    entryState: {},
    entryProps: {},
    entryTrigger: false,
  } as any

  const [transitionState, setTransitionState] = useState(INITIAL_STATE) as any

  return (
    <TransitionContext.Provider value={{ transitionState, setTransitionState }}>
      {children}
    </TransitionContext.Provider>
  )
}

export default TransitionState
